import { create } from 'apisauce';

const authResultKey = 'vrpatients::auth::result';
const authResult = JSON.parse(localStorage.getItem(authResultKey));

const gradingClient = create({
  baseURL: process.env.VUE_APP_GRADING_SERVICE_URL,
  headers: {
    Authorization: authResult ? `Bearer ${authResult.idToken}` : undefined,
  },
});

gradingClient.addResponseTransform((response) => {
  if (!response.ok) {
    throw response.data || new Error('No response from server');
  }
});

export default gradingClient;
